import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function PageHeader({ overline, title, subtitle, image, crumb, imagePosition = "object-center" }) {
  return (
    <section className="relative bg-rc-charcoal text-white pt-32 pb-16 lg:pt-40 lg:pb-20 overflow-hidden">
      {image && (
        <>
          <img src={image} alt="" className={`absolute inset-0 w-full h-full object-cover ${imagePosition}`} />
          <div className="absolute inset-0 bg-gradient-to-r from-rc-charcoal/85 via-rc-charcoal/55 to-rc-charcoal/20" />
        </>
      )}
      <div className="relative max-w-7xl mx-auto px-5 lg:px-8">
        <div className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.2em] text-rc-sand mb-5">
          <Link to="/" className="hover:text-white transition-colors">Home</Link>
          <ChevronRight size={12} />
          <span className="text-white/70">{crumb || overline}</span>
        </div>
        {overline && (
          <div className="font-mono text-rc-red text-xs uppercase tracking-[0.3em] mb-4">{overline}</div>
        )}
        <h1 className="font-heading font-black leading-[0.95] tracking-tight text-[clamp(2.2rem,6vw,4.5rem)] max-w-4xl">
          {title}
        </h1>
        {subtitle && <p className="mt-5 text-white/70 max-w-2xl text-lg leading-relaxed">{subtitle}</p>}
      </div>
    </section>
  );
}
